export const WriteOffsColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Тип',
        key: 'writeOffTypeName',
    },
    {
        name: '№ Накладной',
        key: 'invoiceNumber',
    },
    {
        name: 'Склад',
        key: 'warehouseName',
    },
    {
        name: 'Дата создания',
        key: 'createdAt',
    },
    {
        name: 'Доп. услуга',
        key: 'additionalServiceTypeName',
    },
    {
        name: 'Код 1С',
        key: 'code1C',
    },
    {
        name: 'Cписанные товары',
        key: 'writeOffItems',
    },
    {
        name: 'Плательщик',
        key: 'payerCompanyName',
    },
    {
        name: 'Cтатус',
        key: 'status',
    },
]
